class Product {
    constructor(variant, product) {
        this.id = variant?.id ?? null;
        this.title = product.title ?? product.name;
        this.handle = product.handle ?? null;
        this.shape = product.shape;
        this.price = product.name ? null : (variant?.price).toFixed(2);
        this.weight = product.name ? product.weight : (variant.weight/100);
        this.color = product.color ?? variant.option2;
        this.clarity = product.clarity ?? variant.option1;
        this.cutGrade = product.cut_grade ?? variant.option3;
        if (product.image) {
            this.lab = product.image.alt ?? product.lab;
        } else {
            this.lab = product.lab;
        }
        // this.price_text = '';
        // if (true || this.clarity != 'VVS1') {
        //     this.price_text = 'CA$' + this.price;
        // }
        var miniature = $('<img>').attr('src', product?.image?.src ?? product.img_src);
        // this.tr = $('<a>').attr('href', '/products/' + this.handle).addClass('center').append(
        this.tr = $('<div>').addClass('center').append(
            $('<div class="diamond-img-container">').css('--bg-url', `url("${product?.image?.src ?? product.img_src}")`).append(miniature),
            $('<div>').addClass('h3 bold').append(this.title ?? this.name),
            $('<div>').addClass('h5').append(
                (variant?.option2 ?? product.color ?? '') + 
                ' ' + 
                (variant?.option1 ?? product.clarity ?? '') + 
                ' ' + (this.lab??'') + 
                ' ' + 
                (variant?.option3 ?? product.cut_grade ?? '') + 
                ' ' + 
                this.weight + ' carat'
            ),
            //$('<div>').append(this.shape),
            //$('<td>').append('CAD$' + this.price.toFixed(2)),
            //$('<div>').addClass('h3 bold').append(this.price_text),
            //$('<div>').append(this.lab),
            //$('<div>').append(this.weight),
            //$('<div>').append(variant.option3)
        );
    };
}
